export default class DelayResult {
  public delayCode: string | null = null
  public delayDescription: string | null = null
  public hasDelay = false
}
